import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UmssIconComponent } from '../../icon/icon.component';
import { SetupStep } from '../setup-card.models';

/**
 * A single row of a setup checklist: icon, label, and a trailing state icon.
 *
 * Locked rows are inert — the click never fires and the button is disabled.
 */
@Component({
  selector: 'umss-setup-step',
  standalone: true,
  imports: [UmssIconComponent],
  templateUrl: './setup-step.component.html',
  styleUrl: './setup-step.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UmssSetupStepComponent {
  step = input.required<SetupStep>();
  stepClick = output<SetupStep>();

  protected onClick(): void {
    const step = this.step();
    if (step.locked) return;
    this.stepClick.emit(step);
  }

  protected ariaLabel(step: SetupStep): string {
    if (step.locked) return `${step.label} — locked`;
    if (step.completed) return `${step.label} — completed`;
    return step.label;
  }
}
